if (!customElements.get("custom-buy-button")) {
  customElements.define(
    "custom-buy-button",
    class CustomBuyButton extends HTMLElement {
      constructor() {
        super();
        this.originalBuyButton = document.querySelector(
          ".product__info-container .product-form__submit"
        );
        this.handleObserver();
        this.handleVariantsObserver();
      }

      handleObserver() {
        const observer = new MutationObserver(() => {
          const button = this.querySelector("button");
          if (button) return;
          this.innerHTML = "";

          const cloneBuyButton = this.originalBuyButton.cloneNode(true);
          cloneBuyButton.addEventListener("click", () => {
            this.originalBuyButton.click();
          });
          this.appendChild(cloneBuyButton);

          const tipBuyButton = this.originalBuyButton.cloneNode(true);
          tipBuyButton.addEventListener("click", () => {});
          tipBuyButton.classList.add("tip");
          tipBuyButton.classList.add("disable");
          tipBuyButton.querySelector("span").innerHTML = "SELECT OPTION";
          this.appendChild(tipBuyButton);

          const disabledBuyButton = this.originalBuyButton.cloneNode(true);
          disabledBuyButton.addEventListener("click", () => {
            disabledBuyButton.style.display = "none";
            tipBuyButton.style.display = "block";
          });
          disabledBuyButton.classList.add("disable");
          this.appendChild(disabledBuyButton);

          const variantsCount = Number(this.dataset.variantsCount);
          const hasSelectedVariant = JSON.parse(this.dataset.selectedVariant);
          let canBuy = false;
          if (variantsCount === 1) canBuy = true;
          if (variantsCount > 1 && hasSelectedVariant) canBuy = true;
          
          if (canBuy) {
            cloneBuyButton.style.display = "block";
          } else {
            disabledBuyButton.style.display = "block";
          }
        });
        observer.observe(this.originalBuyButton, { attributes: true });
      }

      handleVariantsObserver() {
        const observer = new MutationObserver(() => {
          const customButton = document.querySelector("custom-buy-button");
          const cloneBuyButton = customButton.querySelector(
            "button:not(.disable)"
          );
          const disabledBuyButtons = customButton.querySelectorAll("button.disable");
          cloneBuyButton.style.display = "block";
          disabledBuyButtons.forEach((disabledBuyButton) => {
            disabledBuyButton.style.display = "none";
          });
        });
        const variantSelects = document.querySelector("variant-selects");
        observer.observe(variantSelects, { attributes: true });
      }
    }
  );
}

if (!customElements.get("scroll-to")) {
  customElements.define(
    "scroll-to",
    class ScrollTo extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", () => {
          const target = this.dataset.target;
          console.log(target);
          document.querySelector(target).scrollIntoView({ 
            behavior: 'smooth',
            block: 'start' // 可选: 'start' | 'center' | 'end' | 'nearest'
          });
        });
      }
    }
  );
}